
import { Component, Vue } from 'vue-property-decorator';
import { UserModule } from '../../store/modules/user';
import { getCompanyInfo, joinCompany } from '../../api/company';
import { getUserToken, setUserToken, setLocUserToken } from '@/utils/cookies';

@Component({
  name: 'CompanyJoin',
  components: {

  }
})
export default class extends Vue {
  private formJoin = {
    id: ''
  }
  private step = 2
  private isActive = false
  private currentComapny:any = {}
  private showError = false
  private errMsg = '';
  private nextHandle() {
    const params = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId ? UserModule.getCompanyId : '0',
      only_id: this.formJoin.id
    };
    if (this.formJoin.id === '') {
      this.showError = true;
      this.errMsg = '请输入正确的单位ID号码';
      return;
    }
    getCompanyInfo(params).then(res => {
      if (res && res.data) {
        this.currentComapny = res.data;
        this.step = 3;
        this.isActive = true;
        this.showError = false;
        this.errMsg = '';
      }
    }).catch(_ => {
      this.showError = true;
      this.errMsg = '请输入正确的单位ID号码';
    });
  }
  private goBack() {
    this.$router.go(-1);
  }
  private preHandle() {
    this.showError = false;
    this.errMsg = '';
    this.step = 2;
    this.isActive = false;
  }
  private handleJoin() {
    const params = {
      user_id: UserModule.getUserId,
      company_id: this.currentComapny.id,
      message: ''
    };
    joinCompany(params).then((res:any) => {
      this.showSecussMsg(res.msg);
      if (res.data && res.data.company && res.data.company.length > 0) {
        let token:any = getUserToken();
        if (typeof token !== 'object') {
          token = JSON.parse(token as string);
        }
        token.company_id = res.data.company[0].id;
        setUserToken(JSON.stringify(token));
        setLocUserToken('');
        this.$router.push({
          path: '/Index'
        });
      } else {
        this.goBack();
      }
      // TODO: 切换公司
    }).catch(err => {
      this.showErrorMsg(err.msg);
    });
  }
  private showErrorMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'error'
    });
  }
  private showSecussMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'success'
    });
  }
}
